import { IRootState } from "../../../redux/root.reducer";
import { createIGSERedux } from "../../../shared/igse-redux/igse-redux-factory";
import { selectAuthTokens } from "../../auth/selectors/auth.selector";
import { ICategoryDto } from "../interface/category.dto";
import { getCategory } from "../service/category.api";

const {
    actions: categoriesActions,
    reducer: categoriesReducer,
    epic: categoriesEpic,
} = createIGSERedux<Array<ICategoryDto>>({
    actionNames: {
        init: "CATEGORY_INIT",
        get: "CATEGORY_GET",
        success: "CATEGORY_SUCCESS",
        error: "CATEGORY_ERROR",
    },
    fetcher: () => getCategory(selectAuthTokens()),
    selector: (state: IRootState) => state.categories,
});

export { categoriesActions, categoriesReducer, categoriesEpic };
